<template>
  <div class="row" v-if="showProgramming">
    <div class="col">
      <b-tabs>
        <b-tab v-for="(day , index) in days" :key="index" :title="day.label" :active="day.value === dayCurrent">
          <table>
            <tr v-for="item in day.contentDays">
              <td>{{ item.nameProgram }}</td>
              <td>{{ item.hourInit.substr(0,5)}} - {{ item.hourFinish.substr(0,5) }}</td>
              <td>
                <div class="avatar"><img :src="item.imageLocutor"></div>
                {{ item.nameLocutor }}
              </td>
            </tr>
          </table>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
  import bTab from 'bootstrap-vue/es/components/tabs/tab'
  import {Tabs} from 'bootstrap-vue/es/components'
  import services from "../service/api";

  export default {
    props: [],
    name: "Programming",
    components: {
      bTabs,
      bTab,
      Tabs
    },
    data() {
      return {
        days: [],
        dayCurrent: '',
        showContent: false,
        programming: null,
        showProgramming: window.config.site.programming,
        stringDays: [
          {
            value: 'SEG',
            label: 'Segunda',
            order: 1
          },
          {
            value: 'TER',
            label: 'Terça',
            order: 2
          },
          {
            value: 'QUA',
            label: 'Quarta',
            order: 3
          },
          {
            value: 'QUI',
            label: 'Quinta',
            order: 4
          },
          {
            value: 'SEX',
            label: 'Sexta',
            order: 5
          },
          {
            value: 'SAB',
            label: 'Sábado',
            order: 6
          },
          {
            value: 'DOM',
            label: 'Domingo',
            order: 0
          }
        ]
      }
    },
    created() {
      let self = this;

      if (self.showProgramming) {
        function compare(a, b) {
          let comparison = 0;
          if (a.order > b.order) {
            comparison = 1;
          } else if (b.order > a.order) {
            comparison = -1;
          }
          return comparison;
        }
        self.days.sort(compare)

        services.getProgramming().then(function (response) {

          // console.log(response.data.result.data)
          if (response.data.result.data) {
            let programming = response.data.result.data;
            self.dayCurrent = programming.currentDayOfWeek;
            self.showContent = true;

            for (let key in programming) {
              // array de dias, com excecao de currentDayOfWeek que vem da api mas é o dia current da semana
              if (key !== 'currentDayOfWeek') {
                let currentDay = '';
                // key = dia
                // pelo visto, para querer incrementar o array de days abaixo
                self.stringDays.forEach(function (value) {
                  // passa uma vez em cada dia
                  if (value.value === key) {
                    currentDay = value;
                  }
                });
                let dayContent = [];
                // foreach nas programacoes do dia, ex array[DOM], no caso, programming tem todos os dias
                programming[key].forEach(function (obj) {
                  dayContent.push(obj);
                });


                self.days.push({
                  value: key,
                  label: currentDay.label,
                  contentDays: dayContent,
                  order: currentDay.order
                });
              }
            }
            self.days.sort(compare);
          }
        });
      }
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Programming.vue